import React, { useState } from "react";
import { IoIosArrowDown } from "react-icons/io";
import { BsPlusSquare } from "react-icons/bs";
import { AiOutlinePlus } from "react-icons/ai";
import { Button, Dropdown, Modal, Space } from "antd";
import { Input, Menu } from "antd";
import PopAddNewClient from "../clients/PopAddNewClient";
import PopBulkUpload from "../clients/PopBulkUpload";
import { SearchOutlined } from "@ant-design/icons";
import ExportModal from "../clients/ExportModal";
import { FormattedMessage } from "react-intl";
import { useIntl } from "react-intl";

const HeadTable = ({
  data,
  setDeleteModal,
  deleteModal,
  searchClient,
  setSearchClient,
  setFilterClient,
  clientsFilter,
}) => {
  const intl = useIntl();

  const [addingClientModal, setAddingClientModal] = useState(false);
  const [clientBulkModal, setClientBulkModal] = useState(false);
  const [exportModal, setExportModal] = useState(false);

  const showModal = () => {
    setAddingClientModal(true);
  };
  const handleCancel = () => {
    setAddingClientModal(false);
  };
  const showBulkModal = () => {
    setClientBulkModal(true);
  };
  const handleBulkCancel = () => {
    setClientBulkModal(false);
  };
  const showExportModal = () => {
    setExportModal(true);
  };
  const handleExportCancel = () => {
    setExportModal(false);
  };

  const items = [
    {
      label: (
        <div
          className="flex text-sm items-center gap-1 px-2 py-1"
          onClick={showModal}
        >
          <AiOutlinePlus className="text-sm flex items-center" />
          <span>
            <FormattedMessage id="AddOneCustomer" />
          </span>
        </div>
      ),
      key: "0",
    },
    {
      type: "divider",
    },
    {
      label: (
        <div
          className="flex text-sm items-center gap-1 px-2 py-1"
          onClick={showBulkModal}
        >
          <AiOutlinePlus className="text-sm flex items-center" />
          <span>
            <FormattedMessage id="BulkUploadToClients" />
          </span>
        </div>
      ),
      key: "1",
    },
  ];

  const filtersItems = [
    {
      label: (
        <div
          onClick={() => {
            setFilterClient("s");
          }}
          className="flex text-sm items-center gap-1 px-2 py-1"
        >
          {/* Your SVG or icon here */}
          <span>
            {intl.formatMessage({
              id: "recentlyAdded",
            })}
          </span>
        </div>
      ),
      key: "0",
    },
    {
      type: "divider",
    },
    {
      label: (
        <div
          onClick={() => {
            setFilterClient("appointments");
          }}
          className="flex text-sm items-center gap-1 px-2 py-1"
        >
          {/* Your SVG or icon here */}
          <span>
            {intl.formatMessage({
              id: "mostBooked",
            })}
          </span>
        </div>
      ),
      key: "1",
    },
  ];

  const renderMenu = (menuItems) => {
    return (
      <Menu>
        {menuItems.map((item) => {
          if (item.type === "divider") {
            return <Menu.Divider key={item.key} />;
          } else {
            return (
              <Menu.Item key={item.key} onClick={item.onClick}>
                {item.label}
              </Menu.Item>
            );
          }
        })}
      </Menu>
    );
  };

  return (
    <>
      <Modal
        width="60%"
        open={addingClientModal}
        onCancel={handleCancel}
        className="max-md:min-w-[95%] max-lg:min-w-[80%]"
        footer={null}
        destroyOnClose
      >
        <PopAddNewClient close={handleCancel} />
      </Modal>
      <Modal
        width="60%"
        open={clientBulkModal}
        destroyOnClose
        className="max-md:min-w-[95%] max-lg:min-w-[80%]"
        onCancel={handleBulkCancel}
        footer={null}
      >
        <PopBulkUpload close={handleBulkCancel} />
      </Modal>
      <Modal
        width="60%"
        centered
        open={exportModal}
        onCancel={handleExportCancel}
        className="max-md:min-w-[95%] max-lg:min-w-[80%]"
        footer={null}
      >
        <ExportModal
          close={handleExportCancel}
          data={data}
          title={intl.formatMessage({
            id: "clients",
            defaultMessage: "العملاء",
          })}
        />
      </Modal>
      <div className="flex items-center justify-between mb-7">
        <div className="w-full flex max-md:flex-col items-center gap-4 max-md:gap-7">
          <div
            onClick={showExportModal}
            className="border-[1px] border-solid border-[#9999A7] w-fit px-3 py-2 flex items-center rounded-lg cursor-pointer bg-white"
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.8579 4.11037C16.9489 4.0228 17 3.90404 17 3.78022C17 3.65639 16.9489 3.53764 16.8579 3.45006L14.4551 1.1373C14.4095 1.09351 14.3553 1.0589 14.2956 1.0355L14.2885 1.03332C14.1749 0.988894 14.0478 0.988894 13.9343 1.03332L13.9272 1.0355C13.8674 1.0588 13.8132 1.09342 13.7677 1.1373L11.3648 3.451C11.2764 3.53907 11.2275 3.65703 11.2286 3.77947C11.2297 3.90191 11.2808 4.01903 11.3707 4.10561C11.4607 4.19219 11.5824 4.2413 11.7096 4.24237C11.8369 4.24343 11.9594 4.19636 12.0509 4.1113L13.626 2.59519V4.08328C13.6244 5.311 13.1168 6.48797 12.2147 7.35604C11.3126 8.22411 10.0895 8.7124 8.81383 8.7138H8.0131C7.88441 8.7138 7.76099 8.763 7.66999 8.85057C7.57899 8.93815 7.52787 9.05692 7.52787 9.18077C7.52787 9.30462 7.57899 9.4234 7.66999 9.51097C7.76099 9.59855 7.88441 9.64775 8.0131 9.64775H8.81383C10.3469 9.64577 11.8166 9.05877 12.9006 8.01548C13.9846 6.97218 14.5945 5.55775 14.5964 4.08235V2.59426L16.1718 4.11037C16.2628 4.19791 16.3862 4.24709 16.5149 4.24709C16.6435 4.24709 16.7669 4.19791 16.8579 4.11037ZM3.74989 3.00001H8.71053C8.83922 3.00001 8.96264 3.0492 9.05364 3.13678C9.14464 3.22435 9.19576 3.34313 9.19576 3.46698C9.19576 3.59083 9.14464 3.70961 9.05364 3.79718C8.96264 3.88476 8.83922 3.93395 8.71053 3.93395H3.90103C3.42932 3.93445 2.97708 4.115 2.64353 4.436C2.30999 4.757 2.12237 5.19223 2.12186 5.64619V12.3538C2.12237 12.8078 2.30999 13.243 2.64353 13.564C2.97708 13.885 3.42932 14.0656 3.90103 14.0661L13.2558 14.0651C13.7266 14.0633 14.1775 13.8822 14.51 13.5613C14.8424 13.2405 15.0293 12.806 15.0298 12.3529V8.7385C15.0298 8.61465 15.0809 8.49587 15.1719 8.4083C15.2629 8.32072 15.3863 8.27152 15.515 8.27152C15.6437 8.27152 15.7671 8.32072 15.8581 8.4083C15.9491 8.49587 16.0003 8.61465 16.0003 8.7385V12.3538C15.9994 13.0554 15.7094 13.728 15.194 14.224C14.6785 14.7201 13.9796 14.9992 13.2506 15H3.74989C3.0209 14.9992 2.32203 14.7201 1.80656 14.224C1.29109 13.728 1.00112 13.0554 1.00027 12.3538V5.64619C1.00112 4.94463 1.29109 4.27204 1.80656 3.77597C2.32203 3.27989 3.0209 3.00083 3.74989 3.00001Z"
                fill="#9999A7"
              />
            </svg>
          </div>
          <Dropdown overlay={renderMenu(filtersItems)} trigger={["click"]}>
            <div className="border-[1px] border-solid border-[#9999A7] w-fit px-3 py-2 flex items-center rounded-lg cursor-pointer bg-white">
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.2008 6.6H2.40078C2.24165 6.6 2.08904 6.53679 1.97652 6.42426C1.864 6.31174 1.80078 6.15913 1.80078 6C1.80078 5.84087 1.864 5.68826 1.97652 5.57574C2.08904 5.46321 2.24165 5.4 2.40078 5.4H10.2008C10.3599 5.4 10.5125 5.46321 10.625 5.57574C10.7376 5.68826 10.8008 5.84087 10.8008 6C10.8008 6.15913 10.7376 6.31174 10.625 6.42426C10.5125 6.53679 10.3599 6.6 10.2008 6.6ZM15.6008 6.6H13.2008C13.0417 6.6 12.889 6.53679 12.7765 6.42426C12.664 6.31174 12.6008 6.15913 12.6008 6C12.6008 5.84087 12.664 5.68826 12.7765 5.57574C12.889 5.46321 13.0417 5.4 13.2008 5.4H15.6008C15.7599 5.4 15.9125 5.46321 16.025 5.57574C16.1376 5.68826 16.2008 5.84087 16.2008 6C16.2008 6.15913 16.1376 6.31174 16.025 6.42426C15.9125 6.53679 15.7599 6.6 15.6008 6.6Z"
                  fill="#9999A7"
                />
                <path
                  d="M11.7008 8.1C11.2854 8.1 10.8794 7.97684 10.5341 7.74609C10.1887 7.51534 9.91958 7.18736 9.76063 6.80364C9.60169 6.41991 9.5601 5.99767 9.64113 5.59031C9.72216 5.18295 9.92217 4.80877 10.2159 4.51508C10.5095 4.22139 10.8837 4.02138 11.2911 3.94035C11.6985 3.85932 12.1207 3.90091 12.5044 4.05985C12.8881 4.2188 13.2161 4.48796 13.4469 4.8333C13.6776 5.17865 13.8008 5.58466 13.8008 6C13.8008 6.55695 13.5795 7.0911 13.1857 7.48492C12.7919 7.87875 12.2577 8.1 11.7008 8.1ZM11.7008 5.1C11.5228 5.1 11.3488 5.15278 11.2008 5.25168C11.0528 5.35057 10.9374 5.49113 10.8693 5.65558C10.8012 5.82004 10.7833 6.001 10.8181 6.17558C10.8528 6.35016 10.9385 6.51053 11.0644 6.6364C11.1903 6.76226 11.3506 6.84798 11.5252 6.88271C11.6998 6.91743 11.8807 6.89961 12.0452 6.83149C12.2097 6.76337 12.3502 6.64802 12.4491 6.50001C12.548 6.35201 12.6008 6.178 12.6008 6C12.6008 5.76131 12.506 5.53239 12.3372 5.3636C12.1684 5.19482 11.9395 5.1 11.7008 5.1ZM15.6008 12.6H7.80078C7.64165 12.6 7.48904 12.5368 7.37652 12.4243C7.264 12.3117 7.20078 12.1591 7.20078 12C7.20078 11.8409 7.264 11.6883 7.37652 11.5757C7.48904 11.4632 7.64165 11.4 7.80078 11.4H15.6008C15.7599 11.4 15.9125 11.4632 16.025 11.5757C16.1376 11.6883 16.2008 11.8409 16.2008 12C16.2008 12.1591 16.1376 12.3117 16.025 12.4243C15.9125 12.5368 15.7599 12.6 15.6008 12.6ZM4.80078 12.6H2.40078C2.24165 12.6 2.08904 12.5368 1.97652 12.4243C1.864 12.3117 1.80078 12.1591 1.80078 12C1.80078 11.8409 1.864 11.6883 1.97652 11.5757C2.08904 11.4632 2.24165 11.4 2.40078 11.4H4.80078C4.95991 11.4 5.11252 11.4632 5.22505 11.5757C5.33757 11.6883 5.40078 11.8409 5.40078 12C5.40078 12.1591 5.33757 12.3117 5.22505 12.4243C5.11252 12.5368 4.95991 12.6 4.80078 12.6Z"
                  fill="#9999A7"
                />
                <path
                  d="M6.29922 14.1C5.88388 14.1 5.47787 13.9768 5.13252 13.7461C4.78718 13.5153 4.51802 13.1874 4.35907 12.8036C4.20013 12.4199 4.15854 11.9977 4.23957 11.5903C4.3206 11.183 4.52061 10.8088 4.8143 10.5151C5.10799 10.2214 5.48217 10.0214 5.88953 9.94035C6.29689 9.85932 6.71913 9.90091 7.10285 10.0599C7.48658 10.2188 7.81455 10.488 8.04531 10.8333C8.27606 11.1786 8.39922 11.5847 8.39922 12C8.39922 12.557 8.17797 13.0911 7.78414 13.4849C7.39032 13.8788 6.85617 14.1 6.29922 14.1ZM6.29922 11.1C6.12122 11.1 5.94721 11.1528 5.79921 11.2517C5.6512 11.3506 5.53585 11.4911 5.46773 11.6556C5.39961 11.82 5.38179 12.001 5.41651 12.1756C5.45124 12.3502 5.53696 12.5105 5.66282 12.6364C5.78869 12.7623 5.94906 12.848 6.12364 12.8827C6.29822 12.9174 6.47918 12.8996 6.64363 12.8315C6.80809 12.7634 6.94865 12.648 7.04754 12.5C7.14644 12.352 7.19922 12.178 7.19922 12C7.19922 11.7613 7.1044 11.5324 6.93562 11.3636C6.76683 11.1948 6.53791 11.1 6.29922 11.1Z"
                  fill="#9999A7"
                />
              </svg>
            </div>
          </Dropdown>
        </div>
        <div className="flex max-md:flex-col items-center w-full gap-5">
          <div className="flex items-center w-full gap-5">
            <Input
              size="small"
              placeholder={intl.formatMessage({
                id: "FindTheClient",
                defaultMessage: "ابحث عن العميل",
              })}
              className="w-full rounded-lg h-full p-2"
              value={searchClient}
              onChange={(e) => setSearchClient(e.target.value)}
              suffix={
                <SearchOutlined
                  style={{
                    color: "#9999A7",
                    position: "absolute",
                    right: 8,
                    top: 12,
                  }}
                />
              }
              style={{ paddingRight: 30 }} // Increase paddingRight to accommodate the icon
            />
          </div>
          <Dropdown overlay={renderMenu(items)} trigger={["click"]}>
            <Button type="primary">
              <Space className="flex items-center justify-center text-center">
                <BsPlusSquare className="h-full flex items-center !text-sm" />
                <span className="text-sm font-semibold">
                  <FormattedMessage id="addNewCustomer" />
                </span>
                <IoIosArrowDown className="h-full flex items-center !text-sm" />
              </Space>
            </Button>
          </Dropdown>
        </div>
      </div>
    </>
  );
};

export default HeadTable;
